import { User } from '../types/dashboard';
import { BackendUser } from '../types/auth';

/**
 * Maps backend user object to frontend User type
 * Transforms role_id from backend API to role string for frontend
 * @param backendUser - User object from backend API
 * @returns Transformed User object for frontend
 */
export const mapBackendUserToFrontend = (backendUser: BackendUser): User => {
  // Map backend role_id to frontend role strings
  const roleMap: Record<number, User['role']> = {
    1: 'trainee',      // Student role
    2: 'trainer',      // Instructor role
    3: 'admin',        // Admin role
    4: 'super_admin'   // Super Admin role
  };

  return {
    id: backendUser.uuid,
    name: `${backendUser.first_name} ${backendUser.last_name}`.trim(),
    email: backendUser.email,
    avatar: backendUser.dp,
    role: roleMap[backendUser.role_id] || 'trainee',
    joinedDate: new Date().toISOString(),
    completedCourses: 0,
    currentPoints: 0,
    level: 1
  };
};
